<template>
  <section class="privacy-policy" :style="{ backgroundImage: `url('${backgroundImage}')` }">
    <div class="privacy-policy__overlay">
      <div class="privacy-policy__container">
        <div class="privacy-policy__card">
          <h1 class="privacy-policy__title">Политика конфиденциальности</h1>

          <article class="privacy-policy__document" v-text="privacyPolicyText"></article>

          <div class="privacy-policy__actions">
            <button type="button" class="privacy-policy__button" @click="goBack">
              Назад
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useRouter } from 'vue-router';

import backgroundImage from '@/assets/login/background-login-page.png';

const router = useRouter();
const privacyPolicyText = `ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ

Настоящая Политика конфиденциальности определяет порядок сбора, обработки, хранения, использования, передачи и защиты персональных данных пользователей сайта bilimal.kz, автоматизированной системы управления «Бiлiмал. Электронды мектеп» / «Бiлiмал. Электронды колледж», а также мобильных приложений Edu-Mark и GradeApp.

Оператором персональных данных является ТОО «Центр инновационных технологий «Өрлеу» (далее - Оператор).

Используя Сайт, Сервис или Мобильное приложение, Пользователь подтверждает, что ознакомлен с настоящей Политикой конфиденциальности и выражает согласие на обработку персональных данных в порядке и на условиях, указанных в настоящем документе.

1. Основные понятия

1.1. Сайт / Сайты - автоматизированные информационные системы, доступные в сети Интернет по сетевым адресам в домене bilimal.kz, включая поддомены.

1.2. Мобильное приложение - программа для ЭВМ, предназначенная для установки и использования на устройстве Пользователя и позволяющая получить доступ к Сервису.

1.3. Сервис - комплекс услуг и функциональных возможностей, предоставляемых Пользователю с использованием Сайта или Мобильного приложения.

1.4. Пользователь - физическое лицо, использующее Сайт, Сервис или Мобильное приложение, включая учащихся, родителей, законных представителей, работников организаций образования и иных лиц, получивших доступ к Сервису.

1.5. Персональные данные - сведения, относящиеся к определенному или определяемому на их основании субъекту персональных данных, включая данные несовершеннолетних лиц.

1.6. Обработка персональных данных - любое действие или совокупность действий, совершаемых с персональными данными, включая сбор, запись, систематизацию, накопление, хранение, уточнение, обновление, изменение, извлечение, использование, передачу, обезличивание, блокирование, удаление и уничтожение.

2. Правовые основания обработки персональных данных

2.1. Обработка персональных данных осуществляется в соответствии с законодательством Республики Казахстан, включая Закон Республики Казахстан от 21 мая 2013 года № 94-V «О персональных данных и их защите», а также иные применимые нормативные правовые акты.

2.2. Оператор обрабатывает персональные данные Пользователей на основании согласия Пользователя или его законного представителя, Пользовательского соглашения, требований законодательства, а также необходимости предоставления образовательного функционала Сайта и Мобильного приложения.

2.3. Если Пользователем является несовершеннолетнее лицо, обработка его персональных данных допускается с согласия и под контролем законного представителя: родителя, усыновителя, опекуна или попечителя.

3. Категории обрабатываемых персональных данных

3.1. Оператор может обрабатывать следующие категории персональных данных:

• фамилия, имя, отчество Пользователя;
• индивидуальный идентификационный номер или бизнес-идентификационный номер;
• контактный телефон;
• адрес электронной почты;
• место жительства;
• сведения об учетной записи, включая идентификаторы, логины и данные авторизации;
• данные об обучении несовершеннолетнего: класс, школа, оценки, расписание, домашние задания, учебные задания и иные образовательные сведения;
• сведения о законных представителях несовершеннолетнего;
• технические данные, необходимые для обеспечения работы Сайта или Мобильного приложения;
• иные данные, необходимые для достижения целей обработки, указанных в настоящей Политике.

3.2. Оператор не осуществляет сбор персональных данных, не связанных с целями предоставления Сервиса, исполнения требований законодательства или обеспечения безопасности Пользователей.

4. Цели обработки персональных данных

4.1. Персональные данные обрабатываются в следующих целях:

• предоставление Пользователю доступа к Сайту, Сервису и Мобильному приложению;
• регистрация, авторизация и идентификация Пользователя;
• предоставление образовательного функционала;
• отображение успеваемости, расписания, заданий, домашних заданий и иных учебных данных;
• обеспечение взаимодействия ученика, родителя или законного представителя и организации образования;
• выполнение требований законодательства Республики Казахстан в сфере образования и защиты персональных данных;
• направление уведомлений, связанных с использованием Сайта, Сервиса или Мобильного приложения;
• обработка обращений, запросов и сообщений Пользователей;
• обеспечение информационной и технической поддержки;
• повышение безопасности, предотвращение несанкционированного доступа и защита данных Пользователей.

5. Обработка данных несовершеннолетних

5.1. Оператор уделяет особое внимание защите персональных данных несовершеннолетних Пользователей.

5.2. Обработка персональных данных несовершеннолетнего осуществляется при наличии согласия законного представителя или иного законного основания, предусмотренного законодательством Республики Казахстан.

5.3. Законный представитель подтверждает, что использование Сайта или Мобильного приложения несовершеннолетним осуществляется с его ведома, согласия и под его контролем.

5.4. Не допускается распространение персональных данных несовершеннолетних лиц, а также данных устройств, используемых ими, без предварительного, явного и информированного согласия законного представителя, за исключением случаев, предусмотренных законодательством.

5.5. Оператор не допускает использование сторонних сервисов аналитики, рекламных сетей или SDK, если такие сервисы осуществляют сбор, обработку или передачу персональных данных несовершеннолетних Пользователей без законного основания.

6. Передача персональных данных третьим лицам

6.1. Оператор вправе передавать персональные данные третьим лицам только в случаях, необходимых для достижения целей обработки, исполнения требований законодательства или предоставления Сервиса.

6.2. Передача персональных данных может осуществляться организациям образования, уполномоченным государственным органам, поставщикам технических услуг и иным лицам при наличии правового основания и при условии соблюдения требований конфиденциальности и защиты персональных данных.

6.3. Оператор не продает персональные данные Пользователей и не передает их третьим лицам для целей, не связанных с предоставлением Сервиса, без согласия Пользователя или его законного представителя.

7. Хранение персональных данных

7.1. Персональные данные хранятся в течение срока действия Пользовательского соглашения, срока эксплуатации Сайта или Мобильного приложения, а также в течение периода наличия активной учетной записи Пользователя.

7.2. В случаях, предусмотренных законодательством, персональные данные могут храниться дольше указанного срока.

7.3. После достижения целей обработки или отзыва согласия персональные данные подлежат удалению, уничтожению или обезличиванию, если иное не предусмотрено законодательством Республики Казахстан.

8. Защита персональных данных

8.1. Оператор принимает необходимые правовые, организационные и технические меры для защиты персональных данных от неправомерного или случайного доступа, уничтожения, изменения, блокирования, копирования, распространения и иных неправомерных действий.

8.2. Доступ к персональным данным предоставляется только уполномоченным лицам, которым такие данные необходимы для выполнения служебных обязанностей или предоставления Сервиса.

8.3. Оператор принимает меры по обеспечению конфиденциальности учетных данных Пользователя. Пользователь самостоятельно отвечает за сохранность логина и пароля и обязан незамедлительно уведомить Оператора о любом несанкционированном доступе к учетной записи.

9. Права Пользователя и законного представителя

9.1. Пользователь или его законный представитель вправе:

• получать информацию о составе и источниках персональных данных, обрабатываемых Оператором;
• требовать уточнения, обновления, блокирования или уничтожения персональных данных, если они являются неполными, устаревшими, неточными, незаконно полученными или не являются необходимыми для заявленной цели обработки;
• отозвать согласие на сбор и обработку персональных данных;
• обращаться к Оператору по вопросам обработки и защиты персональных данных;
• осуществлять иные права, предусмотренные законодательством Республики Казахстан.

9.2. Отзыв согласия на обработку персональных данных может повлечь ограничение доступа к Сайту, Сервису или Мобильному приложению, если обработка таких данных необходима для их работы.

10. Использование файлов cookie и технических данных

10.1. Сайт и Мобильное приложение могут использовать технические данные, необходимые для авторизации, сохранения пользовательской сессии, обеспечения безопасности и корректной работы Сервиса.

10.2. К таким данным могут относиться сведения об устройстве, браузере, операционной системе, IP-адресе, времени доступа и действиях в интерфейсе Сервиса.

10.3. Оператор использует технические данные только в объеме, необходимом для функционирования Сайта, Сервиса, Мобильного приложения, обеспечения безопасности и улучшения качества работы.

11. Изменение Политики конфиденциальности

11.1. Оператор вправе изменять настоящую Политику конфиденциальности в одностороннем порядке.

11.2. Новая редакция Политики конфиденциальности вступает в силу с момента ее публикации на Сайте или в Мобильном приложении, если иной срок не указан в новой редакции.

11.3. Продолжение использования Сайта, Сервиса или Мобильного приложения после публикации новой редакции означает согласие Пользователя с внесенными изменениями.

12. Контактные данные Оператора

Наименование: ТОО «Центр инновационных технологий «Өрлеу»
БИН: 071 040 022 441
Адрес: 100019, г. Караганда, ул. Аманжолова, 5, офис 30
Электронная почта: support@bilimal.kz`;

function goBack() {
  if (window.history.length > 1) {
    router.back();
    return;
  }

  router.push('/login');
}
</script>

<style scoped>
.privacy-policy {
  min-height: 100vh;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}

.privacy-policy__overlay {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
}

.privacy-policy__container {
  width: 100%;
  max-width: 920px;
}

.privacy-policy__card {
  max-width: 1020px;
  margin: 0 auto;
  padding: 20px 18px;
  border-radius: 10px;
  background: rgba(20, 34, 47, 0.72);
  color: #fff;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2);
}

.privacy-policy__title {
  margin: 0 0 16px;
  font-family: Roboto, sans-serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 28px;
  text-align: center;
}

.privacy-policy__document {
  max-height: min(62vh, 680px);
  overflow-y: auto;
  padding-right: 4px;
  font-family: Roboto, sans-serif;
  font-size: 13px;
  line-height: 1.45;
  color: #fff;
  text-align: justify;
  white-space: pre-wrap;
}

.privacy-policy__actions {
  margin-top: 20px;
}

.privacy-policy__button {
  width: 100%;
  min-height: 52px;
  border: 1px solid #00c2ff;
  border-radius: 6px;
  background: #00c2ff;
  color: #fff;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-weight: 500;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
}

.privacy-policy__button:focus-visible {
  outline: 2px solid #fff;
  outline-offset: 2px;
}

@media screen and (min-width: 768px) {
  .privacy-policy__overlay {
    padding: 40px 24px;
  }

  .privacy-policy__card {
    padding: 24px;
  }

  .privacy-policy__title {
    font-size: 26px;
    line-height: 30px;
  }
}
</style>
